/* =========================================================================
   ClueVine — hint orchestration
   Hints themselves are produced by each mode via PuzzleMode.hint(). This module
   holds the small shared policy around them: how long a player can sit without
   progress before the UI gently surfaces the hint affordance (an anti-frustration
   nudge), and the words used to describe hint state.
   ========================================================================= */

/** Idle/no-progress time before Play nudges the player toward a hint. */
export const HINT_NUDGE_MS = 40_000;

/** A friendly, non-judgmental nudge — varied so it doesn't feel robotic. */
export const HINT_NUDGES: readonly string[] = [
  'Stuck? A hint is ready when you want it.',
  'Take your time — a hint is one tap away.',
  'No rush. There’s a hint if you’d like a nudge.',
];

export function pickNudge(seedIndex: number): string {
  return HINT_NUDGES[Math.abs(seedIndex) % HINT_NUDGES.length];
}
